import { httpClient } from '#shared'
import type { CreateChatResponse } from '../model/create-chat-response'

export async function createChat(peerId: number) {
  const response = await httpClient.post<CreateChatResponse>('chats', {
    json: {
      peerId,
      type: 'personal',
    },
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody.data
}
